import {useQuery} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {gqlPaginatorInfo, PaginatiorInfo} from '../../../graphql/common.datatypes';
import {Report} from '../../../graphql/reports.datatypes';
import {gqlReport} from '../ReportDetails/getReportByKey.api';

interface ReportsData {
    reports: {
        data: Report[],
        paginatorInfo: PaginatiorInfo,
    }
}

export const GET_REPORTS_QUERY = gql`
    query getReports($count: Int!, $page: Int!, $where: WhereConditions, $orderBy: [OrderByClause!]){
        reports(first: $count, page: $page, where: $where, orderBy: $orderBy){
          data{
            ${gqlReport}
            user {
                email
            }
          }
          ${gqlPaginatorInfo}
        }
    }
`;

export const getReports = (count: number, page: number, where?: any, orderBy?: any) => useQuery<ReportsData>(
  GET_REPORTS_QUERY,
  {
    variables: {
      count,
      page,
      where,
      orderBy,
    },
  }
);

export default getReports;
